import {
  Checkmark16Filled,
  ClipboardTaskListLtr20Regular,
  DocumentEdit20Regular,
  DocumentText20Regular,
  Lightbulb20Regular,
  PlugConnected20Regular,
  Search20Regular,
} from '@/components/Icon'

const ICONS = {
  thinking: Lightbulb20Regular,
  ready: Checkmark16Filled,
  research: Search20Regular,
  document: DocumentEdit20Regular,
  documents: DocumentText20Regular,
  compose: DocumentEdit20Regular,
  integration: PlugConnected20Regular,
  plan: ClipboardTaskListLtr20Regular,
  tasks: ClipboardTaskListLtr20Regular,
}

/** Map a phase category/id to the rail activity icon. */
export function thoughtStepIcon(categoryOrId, { completed = false } = {}) {
  if (completed) return Checkmark16Filled
  const key = String(categoryOrId ?? '').toLowerCase()
  if (ICONS[key]) return ICONS[key]
  if (key.startsWith('observed:')) return Lightbulb20Regular
  if (key.includes('plan') || key.includes('task')) return ClipboardTaskListLtr20Regular
  if (key.includes('research') || key.includes('search')) return Search20Regular
  if (key.includes('compose') || key.includes('writing')) return DocumentEdit20Regular
  return Lightbulb20Regular
}
